import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

/** Estatus asumido cuando el backend no envía valor. */
const DEFAULT_FLIGHT_STATUS = 'on_time';

@Pipe({
  name: 'flightStatus',
  standalone: false,
  pure: false,
})
export class AmFlightStatusPipe implements PipeTransform {
  constructor(private _traslate: TranslateService) {}

  transform(value: string, ...args: unknown[]): string {
    const status = value?.trim() ? value.trim().toLowerCase() : DEFAULT_FLIGHT_STATUS;
    const key = `flightStatus.${status}`;
    const translated = this._traslate.instant(key);

    // ngx-translate devuelve la propia llave cuando no existe ni en el idioma
    // activo ni en el de fallback. El catálogo `flightStatus` solo cubre
    // on_time, delayed, cancelled, flown, closed y final, mientras que el enum
    // FLIGHT_STATUS incluye además ON_AIR, UNKNOWN, OPENCI y CLOSE. Sin este
    // guard esos estatus se pintaban como "flightStatus.on_air" en el kiosko.
    return !translated || translated === key ? '' : translated;
  }
}
